<template>
  <div class="faq-container">
    <div class="faq-title">
      <h2 class="faq-title-text">{{ $t("web.frequently_asked_questions") }}</h2 >
      <div class="blog-underline"></div>
      <el-divider/>
    </div>
    <div class="faq-list-content">
      <el-collapse v-model="activeNames" accordion>
        <el-collapse-item
            v-for="(faq, index) in faq_list"
            :key="faq.name"
            :title="faq.question"
            :name="index"
            class="collapse-item"
        >
          <template #title>
            <div class="setHeight">
              <div class="faqIcon" :style="getBackgroundImageStyle(faq.icon)">
              </div>
              <!--            <el-image :src="faq.icon" class="faqIcon"></el-image>-->
              <div class="faqQuestion">
                <h3 class="indexH3">{{ faq.question }}</h3>
              </div>
        </div>
          </template>
          <div class="collapse-item-answer">
          {{ faq.answer }}
        </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <!--    <div class="read-more">-->
    <!--      <p class="read-more-text">Read More &gt;</p>-->
    <!--    </div>-->
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeNames: [],
      faq_list: [
        {
          icon: 'https://fronted.familypro.io/familypro/fronted/resource/faqIcon/earth.svg',
          question: this.$t("web.faq.quest.what_is_familypro"),
          answer: this.$t("web.faq.answer.what_is_familypro_answer"),

        },
        {
          icon: 'https://fronted.familypro.io/familypro/fronted/resource/faqIcon/heart.svg',
          question: this.$t("web.faq.quest.what_family_plan_can_i_join_in"),
          answer: this.$t("web.faq.answer.what_family_plan_can_i_join_in_answer"),
        },
        {
          icon: 'https://fronted.familypro.io/familypro/fronted/resource/faqIcon/HomeFilled.svg',
          question: this.$t("web.faq.quest.what_is_family_plan"),
          answer: this.$t("web.faq.answer.what_is_family_plan_answer"),
        },
        {
          icon: 'https://fronted.familypro.io/familypro/fronted/resource/faqIcon/coupon.svg',
          question: this.$t("web.faq.quest.group_purchase"),
          answer: this.$t("web.faq.answer.group_purchase_answer"),
        },
        {
          icon: 'https://fronted.familypro.io/familypro/fronted/resource/faqIcon/picture.svg',
          question: this.$t("web.faq.quest.after_payment"),
          answer: this.$t("web.faq.answer.after_payment_answer"),
        },
        {
          icon: 'https://fronted.familypro.io/familypro/fronted/resource/faqIcon/header.svg',
          question: this.$t("web.faq.quest.own_account"),
          answer: this.$t("web.faq.answer.own_account_answer"),
        },
        {
          icon: 'https://fronted.familypro.io/familypro/fronted/resource/faqIcon/warning.svg',
          question: this.$t("web.faq.quest.buying_legal"),
          answer: this.$t("web.faq.answer.buying_legal_answer"),
        },
        {
          icon: 'https://fronted.familypro.io/familypro/fronted/resource/faqIcon/Vector.svg',
          question: this.$t("web.faq.quest.group_buys"),
          answer: this.$t("web.faq.answer.group_buys_answer"),
        },
        {
          icon: 'https://fronted.familypro.io/familypro/fronted/resource/faqIcon/chat-smile.svg',
          question: this.$t("web.faq.quest.contact_us"),
          answer: this.$t("web.faq.answer.contact_us_answer"),
        }
      ]
    }
  },
  created() {
    this.getFAQ();
  },
  methods: {
    getFAQ() {
      // this.$axios.get('/api/faqs')
      //     .then(response => {
      //       console.log("请求FAQ列表响应参数: ", response);
      //       let result = response.data;
      //
      //       if (result === null || result.code !== 100000 && typeof result === "undefined") {
      //         this.$message({
      //           type: 'error',
      //           // message: result.message,
      //           message: "faq错误"
      //         })
      //       }
      //       this.faq_list = result.data
      //     }).catch(error => {
      //   console.log("请求FAQ列表失败: ", error)
      // })
    },
    getBackgroundImageStyle(url) {
      return {
        backgroundImage: `url(${url})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }
    }
  }
}
</script>
<style scoped>
.faq-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-radius: 6px;
  opacity: 1;
  background: #FFFFFF;
  font-family: 'Alibaba Sans', sans-serif !important;
}

.faq-title {
  width: 100%;
  opacity: 1;
  /* 自动布局 */
  align-items: center;
  text-align: center;
  padding: 0px;
  gap: 8px;
  align-self: stretch;
  color: #FB713C;
  margin-bottom: 35px;
}

.faq-title-text {
  font-family: 'Alibaba Sans', sans-serif;
  font-size: 2rem;
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: 0px;
  color: #121212;
}

.blog-underline {
  width: 100px; /* 横线的宽度 */
  height: 1px;
  background-color: #606266;
  margin: auto;
}

.faq-title :deep(.el-divider) {
  margin: auto;
  padding: 0 !important;
  height: 1px !important;
  width: 906px;
}

.faq-list-content {

  font-family: 'Alibaba Sans', sans-serif !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  line-height: 22px !important;
  letter-spacing: 0px !important;
  text-align: center !important;
  align-content: center;
  width: 50%;
}


.el-collapse-item .el-collapse-item__header .el-collapse-item .collapse-item {
  font-family: 'Alibaba Sans', sans-serif !important;
  font-size: 13px !important;
  font-weight: 700 !important;
  line-height: 22px !important;
  letter-spacing: 0px !important;
  text-align: center !important;
  align-content: center;
  text-align: left;
}

.collapse-item :deep(.el-collapse-item__header) {
  font-family: 'Alibaba Sans', sans-serif !important;
  text-align: left !important;
  font-size: 19px !important;
  font-weight: 700 !important;
  line-height: 48px !important;
  height: auto !important;
  /* display: flex;
  flex-direction: row; */
}

.collapse-item ::v-deep .el-collapse-item__header .el-image {
  /* width: 15px;
  height: 15px; */
  display: flex !important;
  overflow: hidden;
  position: relative;
  height: 18px !important;
  width: 18px !important;
}


.collapse-item-answer {
  font-family: Alibaba Sans;
  font-size: 14px;
  font-weight: normal;
  line-height: 22px;
  letter-spacing: 0px;

  font-variation-settings: "opsz" auto;
  color: #121212;
  text-align: left;
}

.read-more {
  text-align: right;
  margin-top: 20px;
  width: 50%;
}

.read-more-text {
  display: inline-block;
  font-size: 1rem;
  color: #f36b3b;
}

.read-more {
  width: 50%;
  text-align: right; /* 使子元素靠右对齐 */
}

.read-more-text {
  display: inline-block;
  width: auto; /* 根据内容自动调整宽度 */
  height: 19px;
  opacity: 1;
  font-family: 'Alibaba Sans', sans-serif !important;
  font-size: 12px;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0px;
  text-decoration: underline;
  font-variation-settings: "opsz" auto;
  color: #FB713C;
}

.read-more .read-more-text {
  color: #f36b3b;
  text-decoration: underline !important;
  font-size: 1rem;
}

.collapse-item {
}

.setHeight {
  display: flex;
  height: auto;
  justify-content: center;
  align-items: center;
  padding-top: 8px;
  padding-bottom: 8px;
}

.faqIcon {
  width: 18px !important;
  height: 18px !important;
  min-width: 18px !important;
  min-height: 18px !important;
}

.faqQuestion {
  opacity: 1;
  font-family: Alibaba Sans !important;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0px;
  font-variation-settings: "opsz" auto;
  color: #121212;
  margin-left: 12px !important;
}

.indexH3 {
  margin: 0 !important;
  font-family: Alibaba Sans !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  line-height: 22px !important;
  letter-spacing: 0px !important;
  font-variation-settings: "opsz" auto;
  color: #121212;
}

@media (max-width: 768px) {
  .content-container {
    flex-direction: column;
    align-items: center;
  }

  .content-card {
    max-width: 100%;
    margin: 10px 0;
  }
}

/* Mobile styles */
@media (max-width: 768px) {
  .faq-content {
    padding: 10px;
  }

  .faq-list-content {
    width: 80%;
}

  .faq-title :deep(.el-divider) {
    width: 300px !important;
  }

  .faq-title-text {
    font-size: 24px !important;
    font-weight: 800 !important;
    line-height: 32px !important;
    text-align: center !important;
    letter-spacing: 0px !important;
  }

  .el-collapse-item .el-collapse-item__header .el-collapse-item .collapse-item {
    font-size: 12px !important;
    font-weight: 500 !important;
    line-height: 22px !important;
    letter-spacing: 0px !important;
    font-family: 'Alibaba Sans', sans-serif !important;
  }


  .read-more-text {
    font-size: 0.9rem;
  }
}

@media (max-width: 320px) {
  .faq-content {
    margin-top: 97px !important;
  }
}

</style>